import { FileUploadedStatus } from "src/types";
import { useGroupErrorBanner } from "./group-error-banner.hook";
import { Image } from "react-bootstrap";
import { AlertCircleIcon } from "src/assets";

export const GroupErrorBanner = ({
  fileStatus,
}: {
  fileStatus: FileUploadedStatus;
}) => {
  const { getErrorKey, t } = useGroupErrorBanner();

  const GroupListHeader = (
    <div className="d-flex align-items-center">
      <div>
        <div className="font-20-bold c-error align-items-center flex-row d-flex mb-1">
          <Image
            src={AlertCircleIcon}
            width={24}
            height={24}
            className="filter-F34747 me-2"
          />
          <div className="text-uppercase">{t("commons.error_label")}</div>
        </div>
      </div>
    </div>
  );

  const ErrorGroupListContainerDesktop = (
    <div className="d-flex align-items-center justify-content-center group-list-container d-none d-md-block">
      <div className="col-md-12">
        {GroupListHeader}

        {t(getErrorKey(fileStatus))}
      </div>
    </div>
  );

  const ErrorGroupListContainerMobile = (
    <div className="d-flex align-items-center justify-content-center group-list-container d-block d-md-none">
      <div className="col-12">
        {GroupListHeader}
        {t(getErrorKey(fileStatus))}
      </div>
    </div>
  );

  return (
    <>
      {ErrorGroupListContainerDesktop}
      {ErrorGroupListContainerMobile}
    </>
  );
};
